import Vue from "vue";

export const userAccessStore = Vue.observable({
  access: {},
  disabled: {},
  tooltips: {},
});

export const buildUserAccess = (recursos = []) => {
  const access = {};
  const disabled = {};
  const tooltips = {};

  recursos.forEach((menu) => {
    const submenus = Array.isArray(menu?.submenus) ? menu.submenus : [];

    submenus.forEach((submenu) => {
      if (!submenu?.url) return;

      access[submenu.url] = !!submenu.checked && !submenu.disabled;
      disabled[submenu.url] = !!submenu.disabled;

      if (submenu.tooltip) {
        tooltips[submenu.url] = submenu.tooltip;
      }
    });
  });

  return {
    access,
    disabled,
    tooltips,
  };
};

export const setUserAccess = (recursos = []) => {
  const parsedAccess = buildUserAccess(recursos);

  userAccessStore.access = parsedAccess.access;
  userAccessStore.disabled = parsedAccess.disabled;
  userAccessStore.tooltips = parsedAccess.tooltips;

  return parsedAccess;
};
